AFRAME.registerComponent('chart-sectors-dividing-control', {
    schema: {
        width: { type: 'number', default: 5.8 },
        height: { type: 'number', default: 0.95 },
        depth: { type: 'number', default: 0.1 },
        color: { type: 'string', default: '#111111' },
        buttonColor: { type: 'string', default: '#191920' },
        hoverColor: { type: 'string', default: '#2B2B32' },
        selectedColor: { type: 'string', default: '#3636E3' },
        selectedSecondaryAction: { type: 'string', default: 'sec' }
    },

    init: function () {
        this.defaultSelectLabel = ''
        this.selectedButton = null;
        this.scene = document.querySelector('a-scene');
        this.buttons = [];

        this.createButtons();
    },

    createButtons: function () {

        const buttonLabels = ['General', 'Sectors'];
        const actionList = [ 'gen', 'sec']
        this.defaultSelectLabel = 'Sectors'
        const buttonWidth = 2.8;
        const buttonHeight = buttonWidth * 0.4
        const spacing = 0.3;
        const startX = -((buttonWidth * 2 + spacing) / 2) + buttonWidth / 2;
        const startY = 0;
        const z = this.data.depth / 2 + 0.01;

        // this.el.innerHTML = '';
        this.buttons = [];

        buttonLabels.forEach((label, index) => {
            const x = startX + index * (buttonWidth + spacing);
            const position = `${x} ${startY} ${z}`;
            this.createMenuButton(this.el, label, position, buttonWidth, buttonHeight, actionList[index]);
        });
    },

    createMenuButton: function (parent, label, position, buttonWidth, buttonHeight, action) {
        const button = document.createElement('a-entity');
        button.setAttribute('ui-button', {
            label: label,
            type: 'rounded-box',
            width: buttonWidth,
            height: buttonHeight,
            depth: 0.2,
            color: this.data.buttonColor,
            opacity: 0.8,
            autosize: false,
            isSelectable: true,
            selectedColor: this.data.selectedColor,
            radius: 0.2,
            preferredFontSize: 0.3,
        });
        button.setAttribute('position', position);
        button.setAttribute('data-raycastable', '');
        button.setAttribute('data-label', label);
        button.setAttribute('data-action', action);


        button.addEventListener('click', (event) => {
            this.handleMenuAction(action, button);
        });

        parent.appendChild(button);
        this.buttons.push(button);

        if (label === this.defaultSelectLabel) {
            setTimeout(() => {
                this.selectButton(button);
            }, 200);
        }
    },

    handleMenuAction: function (action, button) {
        this.selectButton(button);
        this.el.setAttribute('chart-sectors-dividing-control', 'selectedSecondaryAction',  action);

        const centerPanel = document.getElementById('large-center-panel');
        if (centerPanel) {
            let centerContent = document.getElementById('large-center-panel-content');
            if (centerContent) {
                centerContent.replaceChildren();
                centerContent.setAttribute('position', '0 0 0');
            }
        }

        const primeTypeButton = document.querySelector('#chart-type-control')
        const primeTypeAction = primeTypeButton.getAttribute('chart-type-control')?.selectedPrimeAction

        console.log('action2', primeTypeAction, action)

        if (primeTypeAction === 'gainers' && action === 'gen')   addStockGainersToCenterPanel();
        if (primeTypeAction === 'gainers' && action === 'sec')   addStockGainersSectorToCenterPanel();
        if (primeTypeAction === 'losers' && action === 'gen')    addStockLosersToCenterPanel();
        if (primeTypeAction === 'losers' && action === 'sec')    addStockLosersSectorToCenterPanel();
        if (primeTypeAction === 'topvol' && action === 'gen')    addStockByVolRankCubeToCenterPanel();
        if (primeTypeAction === 'topvol' && action === 'sec')    addStockByVolCubeToCenterPanel();
        if (primeTypeAction === 'topdollar' && action === 'gen') addStockTopDollarCubeToCenterPanel();
        if (primeTypeAction === 'topdollar' && action === 'sec') addStockTopDollarSectorCubeToCenterPanel();
        if (primeTypeAction === 'myportfolio-price')             addMyPortfolioPriceCubeToCenterPanel();
    },

    selectButton: function (button) {
        this.buttons.forEach(btn => {
            if (btn && btn !== button) {
                btn.setAttribute('ui-button', 'selected', false);
                btn.setAttribute('scale', '1 1 1');
            }
        });

        this.selectedButton = button;
        button.setAttribute('ui-button', 'selected', true);
        button.setAttribute('scale', '1.05 1.05 1.05');
    }
});
